import { useState, type ReactNode } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ExcerptImageTab } from "@/components/image-studio/ExcerptImageTab";
import { AppSeo } from "@/components/AppSeo";

const ImageStudio = () => {
  const [tab, setTab] = useState("excerpt-image");
  const [headerActions, setHeaderActions] = useState<ReactNode>(null);

  return (
    <>
    <AppSeo title="Image Studio" />
    <div className="flex min-h-0 flex-col gap-2 lg:gap-3">
      <div className="md:static sticky top-0 z-30 -mx-3 flex shrink-0 flex-col gap-3 border-b border-border bg-background/95 px-3 py-2 backdrop-blur supports-[backdrop-filter]:bg-background/80 md:mx-0 md:border-0 md:bg-transparent md:px-0 md:py-0 md:backdrop-blur-0 lg:flex-row lg:items-end lg:justify-between lg:gap-4">
        <div className="flex items-center justify-between gap-3 lg:flex-1 lg:min-w-0">
          <div className="min-w-0">
            <h1 className="min-w-0 pr-2 font-serif text-2xl font-semibold truncate sm:text-3xl">Image Studio</h1>
            <p className="hidden text-sm text-muted-foreground sm:block">Turn excerpts and ideas into shareable visuals.</p>
          </div>
          <div className="lg:hidden">{headerActions}</div>
        </div>
        <Tabs value={tab} onValueChange={setTab} className="w-full lg:w-auto lg:shrink-0">
          <TabsList className="grid w-full max-w-md grid-cols-3 lg:w-auto">
            <TabsTrigger value="excerpt-image">Excerpt Image</TabsTrigger>
            <TabsTrigger value="social-card" disabled>Social Card · soon</TabsTrigger>
            <TabsTrigger value="cover" disabled>Cover · soon</TabsTrigger>
          </TabsList>
        </Tabs>
        <div className="hidden lg:block">{headerActions}</div>
      </div>

      <Tabs value={tab} onValueChange={setTab} className="flex min-h-0 flex-1 flex-col">
        <TabsContent value="excerpt-image" className="mt-0 flex min-h-0 flex-1 flex-col">
          <ExcerptImageTab renderHeaderActions={setHeaderActions} />
        </TabsContent>
        <TabsContent value="social-card" className="mt-0">
          <ComingSoon title="Social Card" />
        </TabsContent>
        <TabsContent value="cover" className="mt-0">
          <ComingSoon title="Cover" />
        </TabsContent>
      </Tabs>
    </div>
    </>
  );
};

const ComingSoon = ({ title }: { title: string }) => (
  <div className="flex min-h-[40vh] items-center justify-center rounded-lg border border-dashed border-border bg-muted/20 p-8 text-center">
    <div className="space-y-2">
      <p className="font-serif text-lg font-semibold">{title}</p>
      <p className="text-sm text-muted-foreground">Coming soon — this module is on the roadmap.</p>
    </div>
  </div>
);

export default ImageStudio;
